import o from "clsx";
import e from "react";
import { s as a } from "../../../../../RideGlyph.module-CgKw9y7i.mjs";
function h({
  size: t = "small",
  accessibilityTitle: r = "glyph indeterminate",
  className: l,
  "data-testid": n,
  fill: s,
  stroke: m
}) {
  const i = () => o(l, a["ride-glyph"], {
    [a[`size-${t}`]]: t
  });
  return /* @__PURE__ */ e.createElement("div", { className: i(), "data-testid": n }, /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: s || "#03050F",
      stroke: m || "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    r && /* @__PURE__ */ e.createElement("title", null, r),
    /* @__PURE__ */ e.createElement("path", { d: "M17.5 8.75H2.5V11.25H17.5V8.75Z" })
  ));
}
export {
  h as RideGlIndeterminate
};
